// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import VueResource from 'vue-resource';
import VueClipboards from 'vue-clipboards';
import router from './router';
import store from './store';
import VueBlu from 'vue-blu';
import 'vue-blu/dist/css/vue-blu.min.css';
import injector from 'vue-inject';
import VueResourceNProgress from 'vue-resource-nprogress';
import NProgress from 'nprogress';
import "./assets/css/nprogress.css";
import VueTippy from 'vue-tippy';
import VueCookie from 'vue-cookie';
import Vue2TouchEvents from 'vue2-touch-events';
import VueAnalytics from 'vue-analytics';
import App from './App';

window.NProgress = NProgress;

require('./start');

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(VeeValidate, {inject: true});
Vue.use(VueResource);
Vue.use(VueClipboards);
Vue.use(VueBlu);
Vue.use(injector);
Vue.use(VueResourceNProgress);
Vue.use(VueTippy);
Vue.use(VueCookie);
Vue.use(Vue2TouchEvents);
Vue.use(VueAnalytics, {
    id: 'UA‌-57624689-15',
    router
});

// Globals component section
import autocompleteComponent from './components/shared/autocomplete/Autocomplete.component.vue';
import autologoutComponent from './components/shared/autologout/Autologout.component.vue';
import dropdownComponent from './components/shared/dropdown/Dropdown.component.vue';
import paginationComponent from './components/shared/pagination/Pagination.component.vue';

Vue.component('autocomplete-component', autocompleteComponent);
Vue.component('autologout-component', autologoutComponent);
Vue.component('dropdown-component', dropdownComponent);
Vue.component('pagination-component', paginationComponent);

Vue.http.options.emulateJSON = true;
Vue.http.options.credentials = true;
Vue.http.options.root = API;

// Add authorization if available
if (AUTHORIZATION) {
    Vue.http.headers['Authorization'] = AUTHORIZATION;
}

let api = injector.get('api'),
    status = injector.get('status'),
    user = injector.get('user');

const validation = {
    currency: {
        getMessage() {
            return 'The amount should have no more than two decimal places.'
        },
        validate(value) {
            return /^[0-9]+([,.][0-9]{1,2})?$/.test(value);
        }
    },
    digit: {
        getMessage() {
            return 'Your password must have at least one digit.';
        },
        validate(value) {
            return /^.*\d.*$/.test(value);
        }
    },
    greaterThanZero: {
        getMessage() {
            return 'Value must be greater than zero.';
        },
        validate(value) {
            return value > 0;
        }
    },
    isOnList: {
        getMessage() {
            return 'The value provided is not on the list.';
        },
        validate(value, list) {
            let _value = value.toLowerCase();
            let isOnList = list[0].filter(function (obj) {
                let name = obj.name.toLowerCase();
                return name.indexOf(_value) === 0 && name === _value;
            });
            return isOnList.length === 1 && isOnList[0].name.toLowerCase() === _value;
        }
    },
    money: {
        getMessage() {
            return 'Unauthorized characters';
        },
        validate(value) {
            return /^[0-9]+([,.][0-9]+)?$/.test(value);
        }
    },
    phone: {
        getMessage() {
            return 'Unauthorized characters';
        },
        validate(value) {
            return /^[0-9-+() ]+$/.test(value);
        }
    },
    specialChar: {
        getMessage() {
            return 'Your password must have at least one special character.';
        },
        validate(value) {
            return /^.*(?=.*[@#$%^&+=!*?()\\]).+.*$/.test(value);
        }
    }
};
VeeValidate.Validator.extend('currency', validation.currency);
VeeValidate.Validator.extend('digit', validation.digit);
VeeValidate.Validator.extend('greaterThanZero', validation.greaterThanZero);
VeeValidate.Validator.extend('isOnList', validation.isOnList);
VeeValidate.Validator.extend('money', validation.money);
VeeValidate.Validator.extend('phone', validation.phone);
VeeValidate.Validator.extend('specialChar', validation.specialChar);

Vue.http.interceptors.push(
    (request, next) => {
        let auth = store.getters.checkAuth,
            url = request.url;

        let notCheckAgreements = ['auth/logout', 'logout'];

        if (auth && (url !== 'user/fto-accounts')) {
            Vue.cookie.set('FTN_SESSION_TIME', 0);
        }

        next((response) => {
            // Catch response status
            switch (response.status) {
                case 403:
                    if (notCheckAgreements.indexOf(url) < 0) {
                        status['status' + response.status](next);
                    }
                    break;
                case 404:
                case 500:
                    status['status' + response.status](next);
                    break;
                case 503:
                    store.commit('setError', {
                        status: true,
                        code: 503,
                        redirect: true
                    });
                    next({name: 'Dashboard'});
                    break;
            }
        });
    }
);

const checkAuth = (to, from, next) => {
    if (to.matched.some(record => record.meta.Auth)) {
        if (!store.getters.checkAuth) {
            Vue.http.get(api.auth.user).then(response => {
                user.fetchData(response.data).then(() => {
                    if (store.getters.user.position == 0 && !to.matched.some(record => record.meta.noPacket)) {
                        return next({name: 'StartPacket'});
                    } else {
                        return next();
                    }
                })
            }, error => {
                status['status' + error.status](next);
            })
        }
        else {
            if (store.getters.user.position == 0 && !to.matched.some(record => record.meta.noPacket)) {
                return next({name: 'StartPacket'});
            } else {
                return next();
            }
        }
    }
    return next();
};

router.beforeEach((to, from, next) => {
    store.commit('offMobileMenu');

    let isBanned = store.getters.isBanned;

    if (typeof isBanned === 'object') {
        user.isBanned().then(obj => {
            if (obj) {
                store.commit('banned', obj.banned);
                store.commit('location', obj.location);
            }

            return checkAuth(to, from, next);
        });
    } else {
        return checkAuth(to, from, next);
    }
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.js